export default {
  GET_MATCHING_LIST: '/manage/bevolKeyword/findList',
  UPDATE_MATCHING: '/manage/bevolKeyword/update',
  GET_MATCHING_DETAIL: '/manage/bevolKeyword/find',
  CHANGE_MATCHING_STATUS: '/manage/bevolKeyword/enableOperate',
  SEARCH_DLITE_KEYWORD: '/manage/dliteKeyword/filter',
  GET_TRANSLATION_LIST: '/manage/dliteKeyword/findList',
  DEL_TRANSLATION: '/manage/dliteKeyword/delete',
  ADD_TRANSLATION: '/manage/dliteKeyword/save',
  EDIT_TRANSLATION: '/manage/dliteKeyword/update',
  GET_TRANSLATION_DETAIL: '/manage/dliteKeyword/find'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/newCommentKeywords.js